/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-at': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.875A8.075 8.075 0 001.875 10v.625A8.125 8.125 0 0010 18.75h4.375V17.5H10a6.875 6.875 0 01-6.875-6.875V10A6.838 6.838 0 0110 3.125 6.65 6.65 0 0116.875 10c0 2.244-.875 3.125-2.287 3.125-.988 0-1.463-.806-1.463-1.875v-5h-1.25v1.213A2.4 2.4 0 009.687 6.25a3.425 3.425 0 00-3.437 3.4v1.325a3.425 3.425 0 003.438 3.4 2.675 2.675 0 002.5-1.537 2.719 2.719 0 002.443 1.537c1.919 0 3.494-1.25 3.494-4.375A7.95 7.95 0 0010 1.875zm1.875 9.1a2.187 2.187 0 11-4.375 0V9.65a2.188 2.188 0 014.375 0v1.325z"/>'
  }
})
